var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_beards_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_2_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M408.5,353.8c-1.2-9,0.1-13.5-6.7-18c-5.3-3.5-13.8-6.8-19.6-5.4c-2,0.5-7.2,4.4-11.2,5.1 c-6.7,1.4-15.8,2-25-1.1c-5.9-1.9-6.5-4-9.1-5.1c-3.8-1.7-9.3-0.3-12.9,0.9c-6,2-14.7,5.2-18.3,10.8c-4.1,6.5-2.9,20.2-2.8,27.6 c0.1,10.4-1.6,17.3,0.7,24.9c1.6,5.2,5.5,9.9,9.5,14.2c7.8,8.5,15.7,15.2,28.2,16.6c15.2,1.8,38.4,2.5,51.2-7.8 c5-4,10-8.6,13.7-13.8c5-7.1,4.4-11.8,5-20.2C411.7,373.9,409.6,362.2,408.5,353.8z M401.7,352.2c-0.3,5,0.1,13-1.8,17.5 c-2,4.9-5.8,10-10.4,12.8c-4.5,2.7-10,6.1-15.2,3.9c-2.2-0.9-4.7-2.8-5.5-4.9c-1-2.7,1.5-5.3-1.6-6.9c-3.3-1.8-14.7-1.8-18.3-0.4 c-2.1,0.9-2,9.4-7.4,12.3c-4.3,2.3-11.7,0.3-15.6-1.6c-10.4-5.1-13.6-15.6-12.6-26.6c0.5-5.1,0.8-11.5,6.3-13.7 c4.7-1.9,11.9-2.1,17.1-2.3c6-0.1,10.4-0.3,16.5-0.4h5.1c11.4,0,25.4-0.7,36.5,1.1C401.3,344,402.2,344.9,401.7,352.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard2A);
export default __webpack_public_path__ + "static/media/man_beard_2a.99cad4a61c7e4a8ace9a1b15401986e0.svg";
export { ForwardRef as ReactComponent };